import { render, staticRenderFns } from "./systemModelAdd.vue?vue&type=template&id=34896c46&scoped=true&"
import script from "./systemModelAdd.vue?vue&type=script&lang=js&"
export * from "./systemModelAdd.vue?vue&type=script&lang=js&"
import style0 from "./systemModelAdd.vue?vue&type=style&index=0&id=34896c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34896c46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34896c46')) {
      api.createRecord('34896c46', component.options)
    } else {
      api.reload('34896c46', component.options)
    }
    module.hot.accept("./systemModelAdd.vue?vue&type=template&id=34896c46&scoped=true&", function () {
      api.rerender('34896c46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/manage/components/systemModelAdd.vue"
export default component.exports